import axios from 'axios'

const buildQuery = data => {
    // If the data is already a string, return it as-is
    if (typeof data === 'string') return data
    // Create a query array to hold the key/value pairs
    return Object.keys(data).reduce((_qs, key) => {
        const nv = `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        if (_qs) _qs += `&${nv}`
        else _qs = nv
        return _qs
    }, '')
}

const state = {
    types: null,
    vendors: [],
    assets: [],
    asset: null,
    assets_pagination: {},
}

const mutations = {
    SET(state, payload) {
        state.assets = payload
    },

    SET_ASSET_PAGINATION(state, pag) {
        state.assets_pagination = pag
    },

    SET_ASSET(state, payload) {
        state.asset = payload
    },

    SET_TYPES(state, payload) {
        state.types = payload
    },

    SET_VENDORS(state, payload) {
        state.vendors = payload
    },
}

const actions = {
    ////asset

    async get(context, id) {
        const resp = await axios.get(`asset/${id}`)
        console.log('get results', resp)
        const asset = resp.data.success.data
        context.commit('SET_ASSET', asset)
    },

    async fetch(context, params) {
        let { query, page: pg, filters } = params || {}
        query = query || ''
        pg = pg || 1
        filters = filters || {}
        const path = `asset?q=${query}&page=${pg}&${buildQuery(filters)}`
        console.log('--path--', path)
        const results = await axios.get(path)
        console.log('fetch results', results)
        let {
            data,
            current_page: page,
            per_page: pageSize,
            total,
        } = results.data.success.data

        const pag = {
            page,
            pageSize,
            total,
        }

        //const assets = data.data.success.data
        context.commit('SET', data)
        context.commit('SET_ASSET_PAGINATION', pag)
    },

    async create(context, { payload }) {
        const data = await axios.post(`asset`, payload)
        console.log('create results', data)
        context.dispatch('fetch') //not efficient
        //context.commit("SET_TYPE", data.success.data)
    },

    async update(context, { id, payload }) {
        const data = await axios.put(`asset/${id}`, payload)
        console.log('update results', data)
        context.dispatch('fetch') //not efficient
        //context.commit("SET_TYPE", data.success.data)
    },

    async delete(context, id) {
        await axios.delete(`asset/${id}`)
        context.dispatch('fetch') //not efficient
    },

    async listTypes(context) {
        const data = await axios.get(`asset-type`)
        console.log('listType results', data)
        const types = data.data.success.data
        context.commit('SET_TYPES', types)
    },

    async createType(context, { name, description }) {
        const data = await axios.post(`asset-type`, { name, description })
        console.log('createType results', data)
        context.dispatch('listTypes') //not efficient
        //context.commit("SET_TYPE", data.success.data)
    },

    async updateType(context, { id, name, description }) {
        const data = await axios.put(`asset-type/${id}`, { name, description })
        console.log('updateType results', data)
        context.dispatch('listTypes') //not efficient
        //context.commit("SET_TYPE", data.success.data)
    },

    async deleteType(context, id) {
        await axios.delete(`asset-type/${id}`)
        context.dispatch('listTypes') //not efficient
    },

    //////////vendors
    async listVendors(context) {
        const data = await axios.get(`asset-vendor`)
        console.log('listVendors results', data)
        const vendors = data.data.success.data
        context.commit('SET_VENDORS', vendors)
    },

    async createVendor(context, { name, description }) {
        const data = await axios.post(`asset-vendor`, { name, description })
        console.log('createVendor results', data)
        context.dispatch('listVendors') //not efficient
        //context.commit("SET_TYPE", data.success.data)
    },

    async updateVendor(context, { id, name, description }) {
        const data = await axios.put(`asset-vendor/${id}`, {
            name,
            description,
        })
        console.log('updateVendor results', data)
        context.dispatch('listVendors') //not efficient
        //context.commit("SET_TYPE", data.success.data)
    },

    async deleteVendor(context, id) {
        await axios.delete(`asset-vendor/${id}`)
        context.dispatch('listVendors') //not efficient
    },

}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
